export function createICSFile(summary, description, dateString, timeString) {

    // Siempre usar 9:00 AM a 5:00 PM
    const start = new Date(`${dateString}T09:00:00`);
    const end = new Date(`${dateString}T17:00:00`);

    const pad = (num) => (num < 10 ? `0${num}` : `${num}`);
    const formatDate = (date) => {
        return (
            date.getUTCFullYear().toString() +
            pad(date.getUTCMonth() + 1) +
            pad(date.getUTCDate()) +
            'T' +
            pad(date.getUTCHours()) +
            pad(date.getUTCMinutes()) +
            '00Z'
        );
    };


    const icsContent = `BEGIN:VCALENDAR
VERSION:2.0
PRODID:-//Your App Name//EN
BEGIN:VEVENT
UID:${Date.now()}@yourapp.com
DTSTAMP:${formatDate(new Date())}
DTSTART:${formatDate(start)}
DTEND:${formatDate(end)}
SUMMARY:${summary}
DESCRIPTION:${description}
BEGIN:VALARM
TRIGGER:-PT10M
ACTION:DISPLAY
DESCRIPTION:Reminder
END:VALARM
END:VEVENT
END:VCALENDAR`;

    const blob = new Blob([icsContent], { type: 'text/calendar;charset=utf-8' });
    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = 'follow-up.ics';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
}
